import { useLayoutEffect } from 'react'

export default function useHtmlClassNames(classNames: string) {
  useLayoutEffect(() => {
    const [html] = document.getElementsByTagName('html')
    html.className += ' ' + classNames

    return () => {
      html.className = html.className.replace(classNames, '').trim()
    }
  }, [classNames])
}
